// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

window.addEventListener("load", function () {
  console.info("loaded")

const swiper = new Swiper('.swiper', {
    modules: [Navigation, Pagination],
    // Optional parameters
    slidesPerView: 1,
    centerInsufficientSlides: true,
  
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      500: {
        slidesPerView: 2,
      },
      800: {
          slidesPerView: 3,
      },
      1200: {
          slidesPerView: 3,
      },
      1600: {
          slidesPerView: 4,
      },
      2400: {
          slidesPerView: 5,
      }
  }
  });
})